import { loginApi } from '@/service/login/api/login'
import { LoginReq } from '@/service/login/type/login'
import { ProForm, ProFormItem, ProFormText } from '@ant-design/pro-components'
import { Button } from 'antd'
import Cookies from 'js-cookie'
import { setToken } from '@/global.config'
import styles from './index.module.css'
import logo from '@/assets/images/logo.jpg'
import loginIcon from '@/assets/images/login-icon.jpg'
import userIcon from '@/assets/images/user-icon.jpg'  // lxl-新增导入
import passwordIcon from '@/assets/images/password-icon.jpg'  // lxl-新增导入
import eyeDown from '@/assets/images/eye-down.jpg'  // lxl-新增导入
import eyeUp from '@/assets/images/eye-up.jpg'  // lxl-新增导入
import { LockOutlined, UserOutlined } from '@ant-design/icons'
import { useNavigate, Navigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { fetchUserInfoAsync } from '@/store/reducers/userSlice'
import { getDefaultHomePath } from '@/constants/menuPermission'

export default () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  if (Cookies.get('access_token')) {
    return <Navigate to="/" replace />
  }

  // 静默登录aido平台的函数
  const performSilentLogin = async (username: string, password: string) => {
    const response = await fetch('https://combine-next.jarvisbro.com/api/login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include', // 关键：包含cookies
      body: JSON.stringify({ username, password })
    });

    if (!response.ok) {
      throw new Error('Login failed');
    }

    const data = await response.json();

    // 检查返回的状态码和状态信息
    if (data.code !== 200 || data.status !== 'OK') {
      throw new Error(data.status || 'Login failed');
    }

    // 保存登录成功的 token
    if (data.data && data.data.token) {
      localStorage.setItem('business_web_token', data.data.token);
      Cookies.set('vue_admin_template_token', data.data.token);
    }

    return data;
  }

  return (
    <>
      <div className={styles.login}>
        <div className={styles.login_main}>
          <div>
            <div className={styles.login_content}>
              <img className={styles.login_logo} src={logo} alt="" />
              <ProForm<LoginReq>
                className={styles.pro_form}
                submitter={{
                  render: () => null // 不渲染任何按钮
                }}
                onFinish={async values => {
                  try {
                    // 1. 先进行主平台登录
                    const data = await loginApi(values)
                    setToken(data.access_token)
                    Cookies.set('username', values.username) // 新增username存储
                    Cookies.set('password', values.password) // 新增password存储

                    // 2. 然后静默登录aido平台
                    try {
                      const aidoResult = await performSilentLogin(values.username, values.password)
                    } catch (aidoError) {
                      console.error('AIDO平台静默登录失败:', aidoError)
                      // 即使aido登录失败，也继续跳转
                    }

                    // 3. 检查是否切换了账号，如果是才设置刷新标记
                    const previousUsername = localStorage.getItem('current_username')
                    if (previousUsername && previousUsername !== values.username) {
                      // 账号发生了变化，需要刷新数据
                      localStorage.setItem('need_refresh_bot_list', 'true')

                    } else if (previousUsername) {

                    } else {

                    }

                    // 保存当前用户名
                    localStorage.setItem('current_username', values.username)

                    // 4. 通过 Redux thunk 获取用户信息（存入 store，避免 App.tsx 重复请求）
                    try {
                      const userInfo = await dispatch(fetchUserInfoAsync() as any).unwrap()
                      navigate(getDefaultHomePath(userInfo.menus))
                    } catch {
                      navigate('/bots')
                    }
                  } catch (error) {
                    console.error('登录失败:', error)
                    throw error
                  }
                }}
              >
                <ProFormText
                  width="300"
                  name="username"
                  label="Username"
                  // tooltip="最长为 24 位"
                  placeholder="Please Enter Username"
                  fieldProps={{
                    size: 'large',
                    // prefix: <UserOutlined className={'prefixIcon'} />
                    style: {
                      backgroundColor: '#121417',
                      color: '#E5E8EF',
                      border: '1px solid #2A2D36', // 新增边框
                      marginTop: '-7px',
                      transition: 'all 0.3s', // 添加过渡动画
                      // hover 状态
                      ':hover': {
                        borderColor: '#7D8294'
                      },
                    },
                    prefix: (
                      <img
                        src={userIcon}
                        className={'prefixIcon'}
                        style={{
                          width: '16px',
                          height: '16px',
                          marginRight: '8px'
                        }}
                      />
                    )
                  }}
                  rules={[
                    {
                      required: false,
                      message: 'Please Enter Username!',
                    }
                  ]}
                />
                <ProFormText.Password
                  name="password"
                  label="Password"
                  width="300"
                  fieldProps={{
                    size: 'large',
                    // prefix: <LockOutlined className={'prefixIcon'} />
                    style: {
                      backgroundColor: '#121417',
                      color: '#E5E8EF', // 同步修改
                      border: '1px solid #2A2D36',
                      marginTop: '-7px',
                      transition: 'all 0.3s',
                      ':hover': {
                        borderColor: '#7D8294'
                      },
                    },
                    prefix: (
                      <img
                        src={passwordIcon}
                        className={'prefixIcon'}
                        style={{
                          width: '16px',
                          height: '16px',
                          marginRight: '8px'
                        }}
                      />
                    ),
                  }}
                  placeholder={'Please Enter Your Password'}
                  rules={[
                    {
                      required: false,
                      message: 'Please Enter Your Password!',
                    }
                  ]}
                />

                <ProFormItem>
                  <Button
                    className={styles.login_btn}
                    type="primary"
                    htmlType="submit"
                    style={{ width: '300px' }}
                  >
                    Log In
                    <img
                      src={loginIcon}
                      style={{
                        marginLeft: '10px',
                        width: '20px',
                        height: '20px'
                      }}
                    />
                  </Button>
                </ProFormItem>
              </ProForm>
            </div>
            {/* <div className={styles.license} data-v-c1ecada0="">
              <span data-v-c1ecada0="">
                Business Cooperation：sales@jarvisbot.com
              </span>
              <span data-v-c1ecada0="">
                ©2023 Jarvis Bot Pte Ltd. All Rights Reserved.
              </span>
            </div> */}
          </div>

          {/*<img className={styles.logo_pic} src={jarvis_login} alt="" />*/}
        </div>
      </div>
    </>
  )
}
